import Swal from "sweetalert2";
import DOMPurify from 'dompurify';

export const showToast = (title = '', icon = 'error') => {
  const safeTitle = DOMPurify.sanitize(title, { ALLOWED_TAGS: [] }); // Strip all HTML
  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: false,
    didOpen: (toast) => {
      toast.onmouseenter = Swal.stopTimer;
      toast.onmouseleave = Swal.resumeTimer;
    }
  });
  Toast.fire({
    icon: icon,
    title: safeTitle
  });
};

/**
 * Show a confirmation dialog
 * @param {string} title - Dialog title
 * @param {string} text - Dialog text/message
 * @param {string} icon - Icon type (warning, error, success, info, question)
 * @param {string} confirmButtonText - Text for confirm button
 * @param {string} cancelButtonText - Text for cancel button
 * @returns {Promise<boolean>} - Returns true if confirmed, false if cancelled
 */
export const showConfirmDialog = async (
  title = 'Are you sure?',
  text = '',
  icon = 'warning',
  confirmButtonText = 'Yes, proceed',
  cancelButtonText = 'Cancel'
) => {
  const result = await Swal.fire({
    title: title,
    text: text,
    icon: icon,
    showCancelButton: true,
    confirmButtonColor: '#520F81', // $primary from SCSS
    cancelButtonColor: '#F43F5E',   // $danger from SCSS
    confirmButtonText: confirmButtonText,
    cancelButtonText: cancelButtonText,
    reverseButtons: true
  });

  return result.isConfirmed;
};